import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setLoading } from "store/appSlice";

import useViewportDimensions from "hooks/viewport-dimensions";
import General from "./components/general";
import Device from "./components/device";
import AlertTimeline from "./components/alertTimeline";
import Alerts from "./components/alert";
import { alertsGet } from "api/alerts";
import { Alert, Timeline } from "api/types/alerts";

const AlertDetails = () => {
  const { getControlHeight, dimensions } = useViewportDimensions();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  // Extract the filter parameter
  const id = searchParams.get("id");

  const [alert, setAlert] = useState<Alert>(null);
  const [refresh, setRefresh] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState<Timeline>(null);

  const fetchData = async () => {
    dispatch(setLoading(true));
    const { data, status, isLoading } = await alertsGet(id);
    dispatch(setLoading(isLoading));
    if (status && status === 200) {
      setAlert(data);
      // Auto-select the latest timeline event
      if (data?.timeline && data.timeline.length > 0) {
        const sortedEvents = [...data.timeline].sort(
          (a, b) =>
            new Date(b.created).getTime() - new Date(a.created).getTime()
        );
        setSelectedEvent(sortedEvents[0]);
      }
      setTimeout(() => setRefresh((r) => r + 1), 100);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleEventClick = (event: Timeline) => {
    setSelectedEvent(event);
  };

  const cardHeight = useCallback(() => {
    return dimensions.contentHeight - getControlHeight("see") - 15;
  }, [refresh]);

  return (
    <div className={`mt-0 grid w-full grid-cols-1 gap-y-4 px-2 md:px-4`}>
      <div id="see" className="flex flex-col gap-4 lg:flex-row">
        <General alert={alert} id={id} onUpdate={fetchData} />
        <Device alert={alert} onUpdate={fetchData} />
      </div>
      <div
        className="flex flex-col gap-4 lg:flex-row"
        key={`chart-area-${refresh}`}
        style={{ height: cardHeight() }}
      >
        <AlertTimeline
          alert={alert}
          onUpdate={fetchData}
          onEventClick={handleEventClick}
        />
        <Alerts
          alert={alert}
          onUpdate={fetchData}
          selectedEvent={selectedEvent}
        />
      </div>
    </div>
  );
};

export default AlertDetails;
